import React from "react";
import { Header, Icon, Button } from "semantic-ui-react";
import "./DashboardHeader.scss";

export function DashboardHeader(props) {
  const { studentName, gradeName, academicCycle, onRefresh, refreshing } =
    props;

  const firstName = studentName?.split(" ")[0] || "";

  return (
    <div className="dashboard-header">
      <Header as="h2">
        <Icon name="graduation cap" />
        <Header.Content>
          ¡Hola, {firstName}!
          <Header.Subheader>
            <Icon name="book" /> {gradeName} • {academicCycle}
          </Header.Subheader>
        </Header.Content>
      </Header>
      <Button
        icon
        onClick={onRefresh}
        loading={refreshing}
        disabled={refreshing}
      >
        <Icon name="refresh" />
        Actualizar
      </Button>
    </div>
  );
}
